import { Component } from '@verndale/core';
import { calculateLeftBorderHeight } from '../utils';
import { customEvents } from '../helpers/constants';

class Hero extends Component {
  setupDefaults() {
    this.dom = {
      mediaContainer: this.el.querySelector(
        '.mountain-masthead__media-container'
      ),
      mastheadVideo: this.el.querySelector('.mountain-masthead__video'),
      vimeoVideo: this.el.querySelector('.vimeo-video')
    };
    this.setupFallbackImage();
    this.setupLeftBorder();
    this.watchMainElement();
  }

  addListeners() {
    window.addEventListener(customEvents.leftBorderResizeTrigger, () => {
      calculateLeftBorderHeight(
        document.querySelector('.mountain-masthead__left-border')
      );
    });
  }

  watchMainElement() {
    const resizeObserver = new ResizeObserver(entries => {
      calculateLeftBorderHeight(
        document.querySelector('.mountain-masthead__left-border')
      );
    });

    resizeObserver.observe(document.querySelector('body, main'));
  }

  setupFallbackImage() {
    if (!this.dom.mastheadVideo && this.dom.mediaContainer) {
      const fallbackImage = this.dom.mediaContainer.cloneNode(true);
      fallbackImage.classList.add('fallback');
      this.el.append(fallbackImage);
    }
  }

  setupLeftBorder() {
    const leftBorder = document.createElement('div');
    leftBorder.classList.add('mountain-masthead__left-border');
    this.el.append(leftBorder);
    calculateLeftBorderHeight(leftBorder);
  }
}

export default Hero;
